module.exports = __webpack_public_path__ + "static/media/capture.1a311c67.svg";